




































import Vue from 'vue';
export default Vue.extend({
  props: {
    errorMessage: {
      type: String,
      default: ''
    },
    detailErrorMessage: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    showDetailError: false
  }),

  computed: {
    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    },
    detailErrorOccurred(): boolean {
      return this.detailErrorMessage.length > 0;
    }
  },

  methods: {
    toggleDetailError() {
      this.showDetailError = !this.showDetailError;
    },

    clearAllErrors(): void {
      this.showDetailError = false;
      this.$emit('clearErrors');
    }
  }
});
